'use client';

import Image, { type StaticImageData } from 'next/image';
import { useIntl } from 'react-intl';

import messages from '@/components/SimplifiedSignup/Components/QuizResults/messages';

import styles from './styles.module.css';

export type ContentBasedImageProps = {
	/**
	 * @defaultValue
	 * ```tsx
	 * "sisu-content-based-image"
	 * ```
	 */
	'data-testid'?: string;

	src: StaticImageData;
};

export default function ContentBasedImage({
	'data-testid': testId = 'sisu-content-based-image',
	src,
}: ContentBasedImageProps) {
	const { formatMessage } = useIntl();
	return (
		<div className={styles.imageContainer}>
			<Image
				alt={formatMessage(messages.recImage)}
				data-testid={testId}
				fill
				src={src}
				style={{ objectFit: 'contain' }}
				unoptimized
			/>
		</div>
	);
}
